import { render, staticRenderFns } from "./LineupPlayerLoader.vue?vue&type=template&id=3068a62a&"
import script from "./LineupPlayerLoader.vue?vue&type=script&lang=js&"
export * from "./LineupPlayerLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports